import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from 'cn';
import { Slot } from 'radix-ui';
const badgeVariants = cva('group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-4xl border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3!', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground [a]:hover:bg-primary/80',
            secondary: 'bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80',
            destructive: 
            /*
             * ПЕРЕКОМПОНОВКА ДЕСТРУКТИВА - РЕШЕНИЕ ВЛАДЕЛЬЦА 2026-09-25.
             *
             * В поставке текст красный на красной подложке 10 %: 3,98:1 в
             * светлой теме и 4,48:1 в тёмной - ниже AA. Новых цветов не
             * заводим: текст берёт `foreground`, красными остаются значок и
             * рамка. Тон читается, контраст проходит, токены прежние.
             */
            'border-destructive/40 bg-destructive/10 text-foreground *:[svg]:text-destructive focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:focus-visible:ring-destructive/40 [a]:hover:bg-destructive/20',
            outline: 'border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground',
            ghost: 'hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50',
            link: 'text-primary underline-offset-4 hover:underline',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function Badge({ className, variant = 'default', asChild = false, ...props }) {
    const Comp = asChild ? Slot.Root : 'span';
    return (_jsx(Comp, { "data-slot": "badge", "data-variant": variant, className: cn(badgeVariants({ variant }), className), ...props }));
}
export { Badge, badgeVariants };
//# sourceMappingURL=badge.js.map